import * as z from "zod";

export const getChargebacksPaypalAuthUrl = {
  name: "getChargebacksPaypalAuthUrl" as const,
  input: z.object({}),
  output: z.object({ authorizationUrl: z.string() }),
};
